import { MatterQueryParameters } from '~/src/services/api/clioService';

export const keys = {
  all: ['clioMatters'] as const,
  list: (state: MatterQueryParameters) => [...keys.all, { state }] as const,
};
